import classNames from 'classnames';
import { ReactNode } from 'react';

import styles from './Switcher.module.scss';

interface SwitcherProps {
  className?: string;
  children?: ReactNode;
  active: boolean;
  disabled?: boolean;
  onChange: () => void;
  color?: 'red' | 'green';
  dataTestId?: string;
}

export const Switcher = ({ active, className, children, disabled, onChange, color = 'red', dataTestId }: SwitcherProps) => {
  return (
    <div className={classNames(styles.Wrapper, { [styles.Disabled]: disabled }, className)} data-testid={dataTestId} onClick={onChange}>
      <div className={classNames(styles.Switcher, styles[color], { [styles.active]: active })}></div>
      <div>{children}</div>
    </div>
  );
};
